// LoadingService

import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);  // Initial state is false (not loading)
  loading$ = this.loadingSubject.asObservable();  // Observable for loading state

  // Show loading screen
  show() {
    this.loadingSubject.next(true);  // Set loading state to true
  }

  // Hide loading screen
  hide() {
    this.loadingSubject.next(false);  // Set loading state to false
  }
}
